import { useTranslation } from 'react-i18next';
import { FiActivity, FiClock, FiLayers, FiList, FiGitBranch, FiSearch } from 'react-icons/fi';
import './NoRecordsMessage.scss';

const states = {
  symbols: [FiSearch, 'No matching symbols', 'Try a different symbol name or clear your search.'],
  positions: [FiActivity, 'No open positions', 'Your active trades will appear here once a position is opened.'],
  orders: [FiLayers, 'No pending orders', 'Pending buy and sell orders will appear here until they are filled or cancelled.'],
  positionHistory: [FiClock, 'No closed positions', 'Closed trades and their results will appear here.'],
  orderHistory: [FiList, 'No order history yet', 'Filled, cancelled and expired orders will appear here.'],
  strategies: [FiGitBranch, 'No strategies yet', 'Build a strategy to define entry rules, exits and risk settings.'],
  records: [FiList, 'No records yet', 'Records will appear here when available.'],
};
export default function NoRecordsMessage({ variant = 'records', filtered = false, children }) {
  const { t } = useTranslation();
  const [StateIcon, title, hint] = states[variant] || states.records;
  const Icon = filtered ? FiSearch : StateIcon;
  return <div className="table-empty-state" role="status">
    <span className="table-empty-state__icon" aria-hidden="true"><Icon /></span>
    <strong>{filtered ? t('emptyTables.filteredTitle', 'No matching results') : t('emptyTables.' + variant + '.title', title)}</strong>
    <p>{filtered ? t('emptyTables.filteredHint', 'Try another symbol or adjust your filters to see more results.') : t('emptyTables.' + variant + '.hint', hint)}</p>
    {children}
  </div>;
}
